var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: _vm.$style.title,
      staticStyle: {
        height: "calc(100vh - 195px)",
        display: "flex",
        "justify-content": "center",
        "align-items": "center",
        "flex-direction": "column"
      }
    },
    [
      _c("LeftBar", { attrs: { hidden: "" } }),
      _c("h1", { staticClass: "mb-10" }, [_vm._v(" Página não encontrada ")]),
      _c("h3", { staticClass: "mt-10 mb-5" }, [
        _vm._v(" Não foi possível acessar o endereço, mas você pode: ")
      ]),
      _c("br"),
      _c(
        "BaseLink",
        {
          staticClass: "text-primary",
          staticStyle: { "text-decoration": "underline" },
          attrs: { name: "home" }
        },
        [_vm._v(" Voltar para a página inicial ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }